import { showNotification } from "context/notification.service";
import { isImageDoc, resolveDocumentUrl, type DocOwner } from "@components/ui/DocThumbnail";
import { useChatStageStore } from "@store/chatStageStore";

/** Clic droit → « Envoyer au client » : télécharge le document de l'ordre et le pose dans
 *  la zone de saisie de la conversation client, prêt à partir. */
export async function stageDocumentInClientChat(
  doc: { id: string; name: string; type?: string; gcs_path?: string },
  owner: DocOwner,
  discussionId: string | undefined,
): Promise<void> {
  if (!discussionId) {
    showNotification({ type: "error", message: "Pas de conversation client pour cet ordre." });
    return;
  }
  try {
    const url = await resolveDocumentUrl(doc, owner);
    const blob = await (await fetch(url)).blob();
    const file = new File([blob], doc.name, { type: blob.type || "application/octet-stream" });
    useChatStageStore.getState().stage({
      discussionId,
      file,
      type: isImageDoc(doc) ? "image" : "file",
    });
  } catch {
    showNotification({ type: "error", message: "Impossible de récupérer le document." });
  }
}
